// bottom
const ConnectingRoadContactWidthGroup = {
  TEN_METER_OR_MORE: "10m以上",
  SIX_OR_MORE_LESS_THAN_TEN: "6m以上 10m未満",
  TWO_OR_MORE_LESS_THAN_SIX: "2m以上 6m未満",
  LESS_THAN_TWO: "2m未満",
  UNKNOWN: "わからない",
} as const;

export type IConnectingRoadContactWidthGroup = typeof ConnectingRoadContactWidthGroup[keyof typeof ConnectingRoadContactWidthGroup];

export const connectingRoadContactWidthGroupOptions = Object.values(ConnectingRoadContactWidthGroup).map(value => ({
  label: value,
  value,
}));

export const connectingRoadContactWidthGroup = (status: IConnectingRoadContactWidthGroup) => {
  switch (status) {
    case ConnectingRoadContactWidthGroup.TEN_METER_OR_MORE:
      return 1;
    case ConnectingRoadContactWidthGroup.SIX_OR_MORE_LESS_THAN_TEN:
      return 2;
    case ConnectingRoadContactWidthGroup.TWO_OR_MORE_LESS_THAN_SIX:
      return 3;
    case ConnectingRoadContactWidthGroup.LESS_THAN_TWO:
      return 4;
    case ConnectingRoadContactWidthGroup.UNKNOWN:
      return 5;
    default:
      return 0;
  }
};

export default ConnectingRoadContactWidthGroup;
